import { render } from "./Greet.vue?vue&type=template&id=5e8295d6&scoped=true&ts=true"
import script from "./Greet.vue?vue&type=script&lang=ts"
export * from "./Greet.vue?vue&type=script&lang=ts"

import "./Greet.vue?vue&type=style&index=0&id=5e8295d6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e8295d6"]])

export default __exports__